<template>
  <div class="content">
    <div class="content-header">
      <div>
        <div class="content-header__title">Тест ГИМС</div>
        <div class="content-header__subtitle">
          Доступ к тестированию доступен авторизованным пользователям. Пожалуйста, войдите в личный кабинет или зарегистрируйтесь
        </div>
      </div>
      <RouterLink :to="{name: 'setup'}" class="content-header__close">
        <i class="fas fa-times"></i>
      </RouterLink>
    </div>

    <div class="content-form general-testing-access__form">
      <form @submit.prevent="submit">
        <FormField :error="errors.login">
          <input class="input" type="text" v-model="form.login" placeholder="Логин">
        </FormField>
        <FormField :error="errors.password">
          <template #icon>
            <i class="form-icon fas fa-key"></i>
          </template>
          <span class="content-form-password">
            <input class="input" :type="showPassword ? 'text' : 'password'" v-model="form.password" placeholder="Пароль">
            <button type="button" @click="showPassword = !showPassword">
              <i class="fas fa-eye" v-if="!showPassword"></i>
              <i class="fas fa-eye-slash" v-if="showPassword"></i>
            </button>
          </span>
        </FormField>

        <div class="form-actions">
          <RouterLink :to="{name: 'forgot-password'}" class="forgot">Забыли пароль?</RouterLink>
        </div>

        <button class="button primary wide" :disabled="isSending">Войти</button>
        <RouterLink :to="{name: 'register'}" class="button secondary wide general-testing-access__register">
          Зарегистрироваться
        </RouterLink>
      </form>
    </div>
  </div>
</template>

<script>
import {inject, reactive, ref} from "@vue/runtime-core";
import {useRouter} from "vue-router";
import {auth} from "@/data/requests";
import FormField from "@/components/common/FormField";

export default {
  components: {
    FormField
  },
  setup() {
    const router = useRouter();
    const login = inject('login');
    const showPassword = ref(false);
    const isSending = ref(false);
    const errors = ref({});
    const form = reactive({
      login: "",
      password: "",
      remember: false
    });

    async function submit() {
      if (isSending.value) return false;

      isSending.value = true;
      errors.value = {};

      const data = await auth(form);

      if (data.token) {
        await login(data.token);
        await router.push({name: "general-testing"});
        return;
      }

      errors.value = data.errors;
      isSending.value = false;
    }

    return {errors, form, submit, showPassword, isSending};
  }
}
</script>

<style scoped lang="scss">
.general-testing-access__form {
  max-width: 360px;

  @media all and (max-width: 1025px) {
    max-width: 100%;
  }
}

.form-actions {
  margin-top: 24px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 24px;
}

.forgot {
  font-size: 12px;
  color: #086596;
}

.general-testing-access__register {
  box-sizing: border-box;
  margin-top: 12px;
}

.content-form-password {
  position: relative;
}

.content-form-password button {
  position: absolute;
  top: 3px;
  right: 6px;
}
</style>
